/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".myInput[_ngcontent-%COMP%]{height:50px!important;padding:10px!important}"];
export { styles as styles };
